module.exports = __webpack_public_path__ + "43a34b9699c383cf03e1cf24ac18eb37.jpg";